import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Wrapper,
  Section,
  Title,
  TableWrapper,
  UsersTable,
  UsersHeadCell,
  UsersRow,
  UsersCell,
} from "../08_admin/AdminDashboardStyle";
import Roadmap from "../02_myprogress/01_roadmap/Roadmap"; 
import {
  fetchTeacherStudents,
  setSelectedStudent,
  fetchTeacherStudentLessons,
  unlockStudentLesson,
} from "../../features/teacher/teacherSlice";

const TeacherDashboard = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const {
    students,
    loading,
    error,
    selectedStudentId,
    studentLessons,
    lessonsLoading,
    lessonsError,
  } = useSelector((state) => state.teacher);

  useEffect(() => {
    dispatch(fetchTeacherStudents());
  }, [dispatch]);

  // When selected student changes, load that student's lessons
  useEffect(() => {
    if (!selectedStudentId) return;
    dispatch(fetchTeacherStudentLessons(selectedStudentId));
  }, [dispatch, selectedStudentId]);

  const handleSelectStudent = (studentId) => {
    dispatch(setSelectedStudent(studentId));
  };

  const teacherName = user?.name || user?.email;
  const selectedStudent =
    students.find((s) => s.id === selectedStudentId) || null;
  const selectedStudentName =
    selectedStudent?.name || selectedStudent?.email || "";

  const handleTeacherUnlock = (lessonOrder) => {
    if (!selectedStudent) return;
    dispatch(
      unlockStudentLesson({
        studentId: selectedStudent.id,
        lessonOrder,
      })
    );
  };

  return (
    <Wrapper>
      <Section>
        <Title>My Students</Title>

        <TableWrapper>
          {teacherName && selectedStudent && (
            <p style={{ marginBottom: "1rem" }}>
              You are logged in as <strong>{teacherName}</strong> for{" "}
              <strong>{selectedStudentName}</strong>
            </p>
          )}

          {selectedStudent && (
            <p style={{ marginBottom: "1rem" }}>
              <Link to="/myprogress">Open MyProgress for {selectedStudentName}</Link>
            </p>
          )}

          {loading && <p>Loading students...</p>}
          {error && <p style={{ color: "red" }}>Error: {error}</p>}
          {!loading && !error && students.length === 0 && (
            <p>No students assigned to you yet.</p>
          )}

          {!loading && !error && students.length > 0 && (
            <UsersTable>
              <thead>
                <tr>
                  <UsersHeadCell>Select the student</UsersHeadCell>
                  <UsersHeadCell>ID</UsersHeadCell>
                  <UsersHeadCell>Email</UsersHeadCell>
                  <UsersHeadCell>Name</UsersHeadCell>
                </tr>
              </thead>
              <tbody>
                {students.map((s) => (
                  <UsersRow key={s.id}>
                    <UsersCell data-label="Select">
                      <input
                        type="radio"
                        name="selected-student"
                        checked={selectedStudentId === s.id}
                        onChange={() => handleSelectStudent(s.id)}
                      />
                    </UsersCell>
                    <UsersCell data-label="ID">{s.id}</UsersCell>
                    <UsersCell data-label="Email">{s.email}</UsersCell>
                    <UsersCell data-label="Name">{s.name}</UsersCell>

                  </UsersRow>
                ))}
              </tbody>
            </UsersTable>
          )}
        </TableWrapper>

        {/* Roadmap for selected student */}
        {selectedStudent && (
          <TableWrapper>
            <h3>Roadmap for {selectedStudentName}</h3>
            {lessonsLoading && <p>Loading lessons...</p>}
            {lessonsError && (
              <p style={{ color: "red" }}>Error: {lessonsError}</p>
            )}
            {!lessonsLoading && !lessonsError && (
              <Roadmap
                mode="teacher"
                lessons={studentLessons}
                selectedStudentName={selectedStudentName}
                onTeacherUnlock={handleTeacherUnlock}
              />
            )}
          </TableWrapper>
        )}
      </Section>
    </Wrapper>
  );
};

export default TeacherDashboard;
